/**
 * process.env变量由webpack在编译时采用文本替换方式注入
 * 如果直接使用,在代码中会产生大量注入字符串,所以这里将其导出
 * 以方便其他页面使用
 */
const env = process.env;
// 添加VUE_APP_LOCAL变量,根据NODE_ENV值赋值
env.VUE_APP_LOCAL = env.NODE_ENV === 'development';
// 添加VUE_APP_UPLOAD_URL,处理上传地址
env.VUE_APP_UPLOAD_URL = env.VUE_APP_LOCAL
    ? `/uploadPrefix/api/sany/sany/v1/cms/upload`
    : `${env.VUE_APP_SERVER_URL}/api/sany/sany/v1/cms/upload`;
// 上传文件
env.VUE_APP_UPLOAD_FILE = env.VUE_APP_LOCAL
    ? `/serverPrefix/api/pub/v1/common/uploadFileCommon`
    : `${env.VUE_APP_SERVER_URL}/api/pub/v1/common/uploadFileCommon`;
export default env;
